import React, { Component } from 'react'

const PhanQuyenNguoiDungForm = () => {
    return (
      <div>PhanQuyenNguoiDungForm</div>
    )
}

export default PhanQuyenNguoiDungForm